const getBaseUrl = () => {
  if (process.env.NODE_ENV === "production") {
    return "https://scaeback.lentec.com.br";
  } else {
    return "https://scaeback.lentec.com.br";
    // return "https://scaeback.lentec.com.br";
  }
};

export default getBaseUrl;
